<template>
  <!-- Menü/navbar sol üst marka logosu. Vuexy'nin default SVG'si yerine Vişne Madencilik
       kombine logosu. Login ekranı ve loading-bg ile aynı görsel, tutarlı kimlik. -->
  <img
    :src="logo"
    alt="VML - Lojistik Portal"
    class="brand-logo-img"/>
</template>

<script>
import logo from '@/assets/images/logo/ozturelogo.png'

export default {
  data(){
    return { logo }
  }
}
</script>

<style scoped>
.brand-logo-img {
  height: 32px;
  width: auto;
  display: block;
}
</style>
